import { Directive, forwardRef, Input } from '@angular/core';
import { COMPONENT_DEFINITION_REF } from "../../utility/component-definition-token";

@Directive({
    selector: 'aggregated-value',
    providers: [{ provide: COMPONENT_DEFINITION_REF, useExisting: forwardRef(() => AggregatedValueComponent) }]
})
export class AggregatedValueComponent {

    @Input() label: string;

    @Input() aggregation: string;

    @Input() filter: Function | string;

    @Input() unit: string;

}